/* @flow */

import * as React from 'react';

import { Button, Footer, Page, PageContainer, genRuby } from '@sonyged/ext-proc';

import { Customer } from './domain/customer';
import { type FinishedRound, Round } from './domain/Round';
import { type Ingredient, type Topping, ingredientName } from './domain/pizza';
import { Stars } from './Stars';
import AutoScaleContainer from './AutoScaleContainer';
import HintModal from '../../common/HintModal';
import PizzaContainer from './PizzaContainer';
import PizzaCustomerIcon from './icons/PizzaCustomerIcon';

type Props = {
  onNext: FinishedRound => void,
  onRetry: (FinishedRound, FinishedRound) => void,
  round: FinishedRound,
  pastRound: ?FinishedRound,
};

type State = {
  hintModal: boolean,
};

class PizzaResearchResultView extends React.Component<Props, State> {
  static EQUALS = 0;
  static GREATER = 1;
  static LESS = 2;

  static defaultProps = {
    pastRound: null,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      hintModal: false,
      retry: false,
      retryRound: 'past',
    };
  }

  renderResultSale() {
    const pastRound = this.props.pastRound;
    const round = this.props.round;
    const customerRatings = Round.ratings(round);
    const currentDiagnoseResult = round.customers[0].diagnose(round.pizza);
    if (!pastRound) {
      return (
        <React.Fragment>
          <table className="proc-table">
            <thead>
              <tr>
                <th className="left-aligned">しらべた けっか</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div className="proc-result-sale">
                    <div className="proc-result-sale-info">
                      <span className="proc-huge-font">{Round.sale(round)}</span>
                      &nbsp;
                      <span className="proc-medium-font">円</span>
                    </div>
                  </div>
                  <div className="proc-result-rate-star">
                    <Stars satisfactionScore={customerRatings[0].rating} />
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className="proc-result-detail half-half">
                    <div className="left-half">
                      <div className="secondary100-color">気にいった</div>
                      {currentDiagnoseResult.like.map((ingredient, i) => {
                        return (
                          <div key={i} className="gray100-color">
                            {ingredientName(ingredient)}
                          </div>
                        );
                      })}
                      <div className="secondary100-color margin-top">いやだった</div>
                      {currentDiagnoseResult.dislike.map((ingredient, i) => {
                        return (
                          <div key={i} className="gray100-color">
                            {ingredientName(ingredient)}
                          </div>
                        );
                      })}
                    </div>
                    <div className="right-half" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <table className="proc-table">
            <thead>
              <tr>
                <th className="left-aligned">つくった ピザ</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div className="proc-result-sale">
                    <div className="proc-result-sale-info">
                      <div className="proc-small-font gray100-color">
                        {[round.pizza.crust, round.pizza.sauce].concat(round.pizza.toppings).map((ingredient, i) => (
                          <div key={i}>{ingredientName(ingredient)}</div>
                        ))}
                      </div>
                    </div>
                    <div className="proc-result-sale-pizza">
                      <AutoScaleContainer preferedHeight={600} preferedWidth={1080}>
                        <PizzaContainer pizza={round.pizza} />
                      </AutoScaleContainer>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </React.Fragment>
      );
    }

    let diff = PizzaResearchResultView.EQUALS;
    if (Round.sale(pastRound) === Round.sale(round)) {
      diff = PizzaResearchResultView.EQUALS;
    } else if (Round.sale(pastRound) < Round.sale(round)) {
      diff = PizzaResearchResultView.GREATER;
    } else {
      diff = PizzaResearchResultView.LESS;
    }

    const currentRating = Round.ratings(round)[0];
    const pastRating = Round.ratings(pastRound)[0];
    let ratingDiff = PizzaResearchResultView.EQUALS;
    if (currentRating.rating < pastRating.rating) ratingDiff = PizzaResearchResultView.LESS;
    if (currentRating.rating > pastRating.rating) ratingDiff = PizzaResearchResultView.GREATER;

    const pastDiagnoseResult = pastRound.customers[0].diagnose(pastRound.pizza);

    return (
      <React.Fragment>
        <table className="proc-table">
          <thead>
            <tr>
              <th colSpan={2} className="left-aligned">
                しらべた けっか
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              {this.renderSale(
                Round.sale(pastRound),
                PizzaResearchResultView.EQUALS,
                pastRating,
                PizzaResearchResultView.EQUALS,
                'まえの けっか'
              )}
              {this.renderSale(Round.sale(round), diff, currentRating, ratingDiff, genRuby('[今回|こんかい]の けっか'))}
            </tr>
            <tr>
              <td className="proc-result-detail">
                <div className="secondary100-color">気にいった</div>
                {pastDiagnoseResult.like.map((ingredient, i) => {
                  return (
                    <div key={i} className="gray100-color">
                      {ingredientName(ingredient)}
                    </div>
                  );
                })}
                <div className="secondary100-color margin-top">いやだった</div>
                {pastDiagnoseResult.dislike.map((ingredient, i) => {
                  return (
                    <div key={i} className="gray100-color">
                      {ingredientName(ingredient)}
                    </div>
                  );
                })}
              </td>
              <td className="proc-result-detail">
                <div className="secondary100-color">気にいった</div>
                {currentDiagnoseResult.like.map((ingredient, i) => {
                  return (
                    <div key={i} className="gray100-color">
                      {ingredientName(ingredient)}
                    </div>
                  );
                })}
                <div className="secondary100-color margin-top">いやだった</div>
                {currentDiagnoseResult.dislike.map((ingredient, i) => {
                  return (
                    <div key={i} className="gray100-color">
                      {ingredientName(ingredient)}
                    </div>
                  );
                })}
              </td>
            </tr>
          </tbody>
        </table>

        <table className="proc-table">
          <thead>
            <tr>
              <th colSpan={2} className="left-aligned">
                つくった ピザ
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div className="proc-result-sale proc-result-sale--compare">
                  <div className="proc-result-sale-pizza">
                    <AutoScaleContainer
                      preferedHeight={600}
                      preferedWidth={1080}
                      preferedMinWidth={1080}
                      preferedMinHeight={600}
                    >
                      <PizzaContainer pizza={pastRound.pizza} />
                    </AutoScaleContainer>
                  </div>
                  <div className="proc-result-sale-info">
                    <div className="proc-small-font gray100-color">
                      {[pastRound.pizza.crust, pastRound.pizza.sauce]
                        .concat(pastRound.pizza.toppings)
                        .map((ingredient, i) => (
                          <div key={i}>{ingredientName(ingredient)}</div>
                        ))}
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div className="proc-result-sale proc-result-sale--compare">
                  <div className="proc-result-sale-pizza">
                    <AutoScaleContainer
                      preferedHeight={600}
                      preferedWidth={1080}
                      preferedMinWidth={1080}
                      preferedMinHeight={600}
                    >
                      <PizzaContainer pizza={round.pizza} />
                    </AutoScaleContainer>
                  </div>
                  <div className="proc-result-sale-info">
                    <div className="proc-small-font gray100-color">
                      {this.renderIngredient(pastRound.pizza.crust, round.pizza.crust, 'crust')}
                      {this.renderIngredient(pastRound.pizza.sauce, round.pizza.sauce, 'sauce')}
                      {this.renderIngredients(pastRound.pizza.toppings, round.pizza.toppings)}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </React.Fragment>
    );
  }

  renderIngredients(past: Topping[], current: Topping[]): React.Node {
    let diff = false;
    if (past.length !== current.length) {
      diff = true;
    } else {
      past.forEach(function(p, i) {
        if (p !== current[i]) {
          diff = true;
        }
      });
    }
    return current.map((ingredient, i) => (
      <div key={i} className={`${diff ? 'primary20-bg-color' : ''}`}>
        {ingredientName(ingredient)}
      </div>
    ));
  }

  renderIngredient(past: Ingredient, current: Ingredient, key: string) {
    return (
      <div key={key} className={`${past === current ? '' : 'primary20-bg-color'}`}>
        {ingredientName(current)}
      </div>
    );
  }

  renderSale(
    price: number,
    priceDiff: number,
    rating: {| customer: Customer, rating: number |},
    ratingDiff: number,
    title: string
  ) {
    return (
      <td className="proc-result-sale-info">
        <div className={'result-title'}>
          <span className="secondary100-color proc-small-font">{title}</span>
        </div>
        <div className={`gray100-color mb ${this.getSalesClass(priceDiff)}`}>
          <span className="proc-huge-font">{price}</span>
          &nbsp;
          <span className="proc-medium-font">円</span>
          {priceDiff === PizzaResearchResultView.GREATER && <i className={'icon-proc-arrow-up'} />}
          {priceDiff === PizzaResearchResultView.LESS && <i className={'icon-proc-arrow-down'} />}
        </div>
        <br />
        <div className="proc-result-rate-star compare">
          <Stars satisfactionScore={rating.rating} />
          {ratingDiff === PizzaResearchResultView.GREATER && <i className={'icon-proc-arrow-up'} />}
          {ratingDiff === PizzaResearchResultView.LESS && <i className={'icon-proc-arrow-down'} />}
        </div>
      </td>
    );
  }

  getSalesClass(diff: number) {
    if (diff === PizzaResearchResultView.EQUALS) {
      return 'equals compare';
    } else if (diff === PizzaResearchResultView.GREATER) {
      return 'greater compare';
    } else {
      return 'lesser compare';
    }
  }

  render() {
    const hints = [
      'トマトソースと ピーマンは あいしょうが いいよ。',
      'ホワイトソースと サラミは あいしょうが いいよ。',
      'バジルソースと イカは あいしょうが いいよ。',
      '[野|や]さいは、ピーマン、トマト、コーンの ことだよ。',
      'お[肉|にく]は、サラミ、ベーコン、チキンの ことだよ。',
      'コーンは 子どもに 人気だよ。',
      'ベーコンは 子どもに 人気だよ。',
      'イカは 子どもに 人気だよ。',
      'エビは 子どもに 人気だよ。',
      'ピーマンは おとなに 人気だよ。',
      'トマトは おとなに 人気だよ。',
      'チキンは おとなに 人気だよ。',
      'カニは おとなに 人気だよ。',
      'おなかが ペコペコの 人は、ふっくら きじだと よろこぶよ。',
      'おなかが すいて いる 人は、ふつうの きじだと よろこぶよ。',
    ];
    if (this.state.hintModal) {
      return <HintModal message={genRuby(hints[Math.floor(Math.random() * hints.length)])} kind={'pizza'} />;
    }

    const {
      round: { customers },
    } = this.props;

    return (
      <div className={`pizza-inner-view pizza-result-view white-bg-color`}>
        <Page.fluid className={`gray5-bg-color research pizza-customerInfo`} fullHeight={false}>
          <PageContainer.small className="pizza-customerInfo-container">
            <div className="pizza-customers">
              <PizzaCustomerIcon talking={true} onRequestToTalk={() => {}} customer={customers[0]} />
            </div>
          </PageContainer.small>
        </Page.fluid>

        <Page.fluid menu={false} fullHeight={false} className="gray10-bg-color research flex1">
          <PageContainer.normal>{this.renderResultSale()}</PageContainer.normal>
        </Page.fluid>

        {this.renderFooter()}
      </div>
    );
  }

  renderFooter() {
    const pastRound = this.props.pastRound;

    return (
      <Footer.normal className="white-bg-color">
        {pastRound && <Button.normal onClick={this.handleRetryClick}>もういちど</Button.normal>}
        {this.renderNextButton()}
      </Footer.normal>
    );
  }

  renderNextButton() {
    const pastRound = this.props.pastRound;
    if (pastRound) {
      return <Button.attention onClick={this.onHintClick.bind(this)}>しゅうりょう</Button.attention>;
    }

    return <Button.attention onClick={this.onNextClick.bind(this)}>つぎへ</Button.attention>;
  }

  handleRetryClick = () => {
    if (this.props.pastRound) this.props.onRetry(this.props.pastRound, this.props.round);
  };

  onNextClick() {
    this.props.onNext(this.props.round);
  }

  onHintClick() {
    this.setState({ hintModal: true });
  }
}

export default PizzaResearchResultView;
